import './waitingToReturnTab.scss';
import WaitingToReturnSearch from './waitingToReturnSearch/waitingToReturnSearch';
import WaitingToReturnTable from './waitingToReturnTable/waitingToReturnTable';
import type { WaitingToReturnTabProps } from './waitingToReturnTab.types';

/**
 * Renders the Waiting for Return tab of the Fleet page as its search bar stacked above the device table. Forwards hasTitle to the search component so the tab can be shown with or without its heading.
 *
 * @param hasTitle - Whether the search area renders its title.
 * @returns The waiting-to-return tab element.
 */
const WaitingToReturnTab = ({ hasTitle }: WaitingToReturnTabProps) => (
  <div className="waiting-to-return-tab">
    <WaitingToReturnSearch hasTitle={hasTitle} />
    <WaitingToReturnTable />
  </div>
);

export default WaitingToReturnTab;
